export const treeJoinList = async (nodes: any) => {
    const nodeMap:any = {};   // 哈希表存储所有节点
    const roots:any = [];     // 存储根节点
    
    // 第一次遍历：初始化节点并创建映射
    nodes.forEach((node:any) => {
        nodeMap[node.id] = { ...node, router: [] }; // 深拷贝避免污染原数据
    });
    
    // 第二次遍历：建立父子关系
    nodes.forEach((node:any) => {
        const parentNode = nodeMap[node.pid];
        if (parentNode) {
        parentNode.router.push(nodeMap[node.id]); // 将当前节点加入父节点的 router
        } else {
        roots.push(nodeMap[node.id]); // 没有父节点则视为根节点
        }
    });
    
    return roots; // 返回所有根节点组成的树
}

export const treeJoinList2 = async (nodes: any) => {
    const nodeMap:any = {};   // 哈希表存储所有节点
    const roots:any = [];     // 存储根节点
    
    // 第一次遍历：初始化节点并创建映射
    nodes.forEach((node:any) => {
        nodeMap[node.menuId] = { ...node, children: [] }; // 深拷贝避免污染原数据
    });
    
    // 第二次遍历：建立父子关系
    nodes.forEach((node:any) => {
        const parentNode = nodeMap[node.parentId];
        if (parentNode) {
            nodeMap[node.menuId].path = parentNode.path + '/' + nodeMap[node.menuId].path
            parentNode.children.push(nodeMap[node.menuId]); // 将当前节点加入父节点的 router
        } else {
        roots.push(nodeMap[node.menuId]); // 没有父节点则视为根节点
        }
    });
    
    return roots; // 返回所有根节点组成的树
}

export const isValidIDCard = (id: string) => {
  // 1. 格式校验
  const regex = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
  if (!regex.test(id)) return false;
 
  // 2. 日期有效性验证
  const year = parseInt(id.slice(6, 10));
  const month = parseInt(id.slice(10, 12));
  const day = parseInt(id.slice(12, 14));
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) return false;
 
  // 3. 校验码计算
  const factors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const codes = '10X98765432';
  const sum = id
    .slice(0, 17)
    .split('')
    .reduce((acc, char, index) => acc + parseInt(char) * factors[index], 0);
  const checkCode = codes[sum % 11];
  return id[17] === checkCode;
}